// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.FooterSection_footer__Pbo9H {
  width: 100%;
  background: #f6fcfc;
  padding: 0;
  border-top: 1px solid #e6e6e6;
  font-family: inherit;
}

.FooterSection_topRow__0kKpq {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  max-width: 1200px;
  margin: 0 auto;
  padding: 48px 0 24px 0;
  gap: 48px;
  flex-wrap: nowrap;
}

.FooterSection_mapCol__Oqojk {
  flex: 0 0 220px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.FooterSection_mapImg__svxkq {
  width: 200px;
}

/* Adres paneli */
.FooterSection_addressCol__FCndj {
  flex: 0 0 250px;
  max-width: 250px;
  overflow: visible;
  opacity: 1;
  transform: translateX(0);
  transition: flex-basis 420ms ease, max-width 420ms ease, opacity 420ms ease, transform 420ms ease;
  will-change: flex-basis, max-width, opacity, transform;
}

.FooterSection_addressContent__3iFUo {
  display: flex;
  flex-direction: column;
  min-width: 200px;
  text-align: center;
}

.FooterSection_addressLines__CFzq3 {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 6px;
  align-items: center;
}
.FooterSection_addressLines__CFzq3 ul {
  list-style: none;
  padding: 0;
  margin: 0;
}
.FooterSection_addressLines__CFzq3 ul li {
  position: relative;
  padding-left: 20px;
}
.FooterSection_addressLines__CFzq3 ul li::before {
  content: "•";
  position: absolute;
  left: 0;
  color: #c964b7;
  font-weight: bold;
  font-size: 1.2em;
}
.FooterSection_addressLines__CFzq3 ul li div {
  margin-bottom: 2px;
}
.FooterSection_addressLines__CFzq3 ul li div:last-child {
  margin-bottom: 0;
}

.FooterSection_addressContent__3iFUo a {
  display: inline-flex;
  align-items: center;
  color: #222;
  text-decoration: none;
  font-size: 1rem;
  margin-bottom: 8px;
  transition: color 0.2s;
}

.FooterSection_addressContent__3iFUo a:hover {
  color: #c964b7;
}

.FooterSection_mapLink__GSW96 {
  text-decoration: underline;
}

/* Link kolonları */
.FooterSection_linksCol__qWccj {
  flex: 1 1;
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 0;
}

.FooterSection_linksGrid__k6gXS {
  display: grid;
  grid-template-columns: repeat(2, minmax(200px, 1fr));
  gap: 48px;
  width: 100%;
  max-width: none;
  justify-items: center;
}

.FooterSection_colTitle__VuhUN {
  font-weight: 700;
  color: #222;
  margin-bottom: 10px;
  font-size: 1.08rem;
  text-align: center;
}

.FooterSection_linksGrid__k6gXS a {
  display: flex;
  align-items: center;
  justify-content: center;
  color: #222;
  text-decoration: none;
  font-size: 1rem;
  margin-bottom: 8px;
  transition: color 0.2s;
}

.FooterSection_linksGrid__k6gXS a:hover {
  color: #c964b7;
}

/* Alt satır */
.FooterSection_bottomRow__nSB-h {
  width: 100%;
  text-align: center;
  padding: 18px 0 12px 0;
  font-size: 0.98rem;
  border-top: 1px solid #e6e6e6;
}

/* Mobil */
@media (max-width: 900px) {
  .FooterSection_topRow__0kKpq {
    flex-direction: column;
    align-items: center;
    padding: 32px 0 12px 0;
    gap: 24px;
    flex-wrap: nowrap;
  }
  .FooterSection_mapCol__Oqojk {
    justify-content: center;
    margin-bottom: 0;
    align-self: center;
  }
  .FooterSection_mapImg__svxkq {
    width: 250px;
    bottom: 1rem;
  }
  .FooterSection_addressCol__FCndj {
    width: 100%;
    max-width: 100%;
    flex-basis: auto;
    opacity: 1;
    transform: translateY(0);
    max-height: none;
    overflow: visible;
    margin-bottom: 0;
  }
  .FooterSection_addressCol__FCndj.FooterSection_open__StmXR {
    opacity: 1;
    transform: translateY(0);
    max-height: none;
  }
  .FooterSection_linksCol__qWccj {
    width: 100%;
    justify-content: center;
  }
  .FooterSection_linksGrid__k6gXS {
    grid-template-columns: 1fr;
    gap: 24px;
    max-width: 100%;
    width: 100%;
    justify-items: center;
  }
  /* Tüm bölümleri ortalayıp mesafeleri eşitle */
  .FooterSection_addressContent__3iFUo {
    text-align: center;
  }
  .FooterSection_addressContent__3iFUo .FooterSection_colTitle__VuhUN {
    text-align: center;
    margin-bottom: 10px;
  }
  .FooterSection_addressLines__CFzq3 {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 8px;
  }
  .FooterSection_linksGrid__k6gXS > div {
    text-align: center;
  }
  .FooterSection_linksGrid__k6gXS .FooterSection_colTitle__VuhUN {
    text-align: center;
  }
  .FooterSection_linksGrid__k6gXS a {
    justify-content: center;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/FooterSection/FooterSection.module.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB;EACE,WAAA;EACA,mBAAA;EACA,UAAA;EACA,6BAAA;EACA,oBAAA;AAEF;;AACA;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,uBAAA;EACA,iBAAA;EACA,cAAA;EACA,sBAAA;EACA,SAAA;EACA,iBAAA;AAEF;;AACA;EACE,eAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAEF;;AACA;EACE,YAAA;AAEF;;AACA,iBAAA;AACA;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,UAAA;EACA,wBAAA;EACA,iGAAA;EACA,sDAAA;AAEF;;AACA;EACE,aAAA;EACA,sBAAA;EACA,gBAAA;EACA,kBAAA;AAEF;;AACA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,kBAAA;EACA,mBAAA;AAEF;AAAE;EACE,gBAAA;EACA,UAAA;EACA,SAAA;AAEJ;AAAI;EACE,kBAAA;EACA,kBAAA;AAEN;AAAM;EACE,YAAA;EACA,kBAAA;EACA,OAAA;EACA,cAAA;EACA,iBAAA;EACA,gBAAA;AAER;AACM;EACE,kBAAA;AACR;AACQ;EACE,gBAAA;AACV;;AAMA;EACE,oBAAA;EACA,mBAAA;EACA,WAAA;EACA,qBAAA;EACA,eAAA;EACA,kBAAA;EACA,sBAAA;AAHF;;AAKA;EACE,cAAA;AAFF;;AAKA;EACE,0BAAA;AAFF;;AAKA,mBAAA;AACA;EACE,SAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;AAFF;;AAKA;EACE,aAAA;EACA,oDAAA;EACA,SAAA;EACA,WAAA;EACA,eAAA;EACA,qBAAA;AAFF;;AAKA;EACE,gBAAA;EACA,WAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;AAFF;;AAKA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,qBAAA;EACA,eAAA;EACA,kBAAA;EACA,sBAAA;AAFF;;AAIA;EACE,cAAA;AADF;;AAIA,cAAA;AACA;EACE,WAAA;EACA,kBAAA;EACA,sBAAA;EACA,kBAAA;EACA,6BAAA;AADF;;AAIA,UAAA;AACA;EACE;IACE,sBAAA;IACA,mBAAA;IACA,sBAAA;IACA,SAAA;IACA,iBAAA;EADF;EAIA;IACE,uBAAA;IACA,gBAAA;IACA,kBAAA;EAFF;EAKA;IACE,YAAA;IACA,YAAA;EAHF;EAMA;IACE,WAAA;IACA,eAAA;IACA,gBAAA;IACA,UAAA;IACA,wBAAA;IACA,gBAAA;IACA,iBAAA;IACA,gBAAA;EAJF;EAOA;IACE,UAAA;IACA,wBAAA;IACA,gBAAA;EALF;EAQA;IACE,WAAA;IACA,uBAAA;EANF;EASA;IACE,0BAAA;IACA,SAAA;IACA,eAAA;IACA,WAAA;IACA,qBAAA;EAPF;EAUA,8CAAA;EACA;IACE,kBAAA;EARF;EAWA;IACE,kBAAA;IACA,mBAAA;EATF;EAYA;IACE,aAAA;IACA,sBAAA;IACA,mBAAA;IACA,QAAA;EAVF;EAaA;IACE,kBAAA;EAXF;EAcA;IACE,kBAAA;EAZF;EAeA;IACE,uBAAA;EAbF;AACF","sourcesContent":[".footer {\n  width: 100%;\n  background: #f6fcfc;\n  padding: 0;\n  border-top: 1px solid #e6e6e6;\n  font-family: inherit;\n}\n\n.topRow {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 48px 0 24px 0;\n  gap: 48px;\n  flex-wrap: nowrap;\n}\n\n.mapCol {\n  flex: 0 0 220px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.mapImg {\n  width: 200px;\n}\n\n/* Adres paneli */\n.addressCol {\n  flex: 0 0 250px;\n  max-width: 250px;\n  overflow: visible;\n  opacity: 1;\n  transform: translateX(0);\n  transition: flex-basis 420ms ease, max-width 420ms ease, opacity 420ms ease, transform 420ms ease;\n  will-change: flex-basis, max-width, opacity, transform;\n}\n\n.addressContent {\n  display: flex;\n  flex-direction: column;\n  min-width: 200px;\n  text-align: center;\n}\n\n.addressLines {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  margin-bottom: 6px;\n  align-items: center;\n\n  ul {\n    list-style: none;\n    padding: 0;\n    margin: 0;\n\n    li {\n      position: relative;\n      padding-left: 20px;\n\n      &::before {\n        content: \"•\";\n        position: absolute;\n        left: 0;\n        color: #c964b7;\n        font-weight: bold;\n        font-size: 1.2em;\n      }\n\n      div {\n        margin-bottom: 2px;\n\n        &:last-child {\n          margin-bottom: 0;\n        }\n      }\n    }\n  }\n}\n\n.addressContent a {\n  display: inline-flex;\n  align-items: center;\n  color: #222;\n  text-decoration: none;\n  font-size: 1rem;\n  margin-bottom: 8px;\n  transition: color 0.2s;\n}\n.addressContent a:hover {\n  color: #c964b7;\n}\n\n.mapLink {\n  text-decoration: underline;\n}\n\n/* Link kolonları */\n.linksCol {\n  flex: 1 1 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 0;\n}\n\n.linksGrid {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(200px, 1fr));\n  gap: 48px;\n  width: 100%;\n  max-width: none;\n  justify-items: center;\n}\n\n.colTitle {\n  font-weight: 700;\n  color: #222;\n  margin-bottom: 10px;\n  font-size: 1.08rem;\n  text-align: center;\n}\n\n.linksGrid a {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #222;\n  text-decoration: none;\n  font-size: 1rem;\n  margin-bottom: 8px;\n  transition: color 0.2s;\n}\n.linksGrid a:hover {\n  color: #c964b7;\n}\n\n/* Alt satır */\n.bottomRow {\n  width: 100%;\n  text-align: center;\n  padding: 18px 0 12px 0;\n  font-size: 0.98rem;\n  border-top: 1px solid #e6e6e6;\n}\n\n/* Mobil */\n@media (max-width: 900px) {\n  .topRow {\n    flex-direction: column;\n    align-items: center;\n    padding: 32px 0 12px 0;\n    gap: 24px;\n    flex-wrap: nowrap;\n  }\n\n  .mapCol {\n    justify-content: center;\n    margin-bottom: 0;\n    align-self: center;\n  }\n\n  .mapImg {\n    width: 250px;\n    bottom: 1rem;\n  }\n\n  .addressCol {\n    width: 100%;\n    max-width: 100%;\n    flex-basis: auto;\n    opacity: 1;\n    transform: translateY(0);\n    max-height: none;\n    overflow: visible;\n    margin-bottom: 0;\n  }\n\n  .addressCol.open {\n    opacity: 1;\n    transform: translateY(0);\n    max-height: none;\n  }\n\n  .linksCol {\n    width: 100%;\n    justify-content: center;\n  }\n\n  .linksGrid {\n    grid-template-columns: 1fr;\n    gap: 24px;\n    max-width: 100%;\n    width: 100%;\n    justify-items: center;\n  }\n\n  /* Tüm bölümleri ortalayıp mesafeleri eşitle */\n  .addressContent {\n    text-align: center;\n  }\n\n  .addressContent .colTitle {\n    text-align: center;\n    margin-bottom: 10px;\n  }\n\n  .addressLines {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 8px;\n  }\n\n  .linksGrid > div {\n    text-align: center;\n  }\n\n  .linksGrid .colTitle {\n    text-align: center;\n  }\n\n  .linksGrid a {\n    justify-content: center;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"footer": `FooterSection_footer__Pbo9H`,
	"topRow": `FooterSection_topRow__0kKpq`,
	"mapCol": `FooterSection_mapCol__Oqojk`,
	"mapImg": `FooterSection_mapImg__svxkq`,
	"addressCol": `FooterSection_addressCol__FCndj`,
	"addressContent": `FooterSection_addressContent__3iFUo`,
	"addressLines": `FooterSection_addressLines__CFzq3`,
	"mapLink": `FooterSection_mapLink__GSW96`,
	"linksCol": `FooterSection_linksCol__qWccj`,
	"linksGrid": `FooterSection_linksGrid__k6gXS`,
	"colTitle": `FooterSection_colTitle__VuhUN`,
	"bottomRow": `FooterSection_bottomRow__nSB-h`,
	"open": `FooterSection_open__StmXR`
};
export default ___CSS_LOADER_EXPORT___;
